import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { SecretariatStore } from '../../store/SecretariatStore';
import { Secretariat } from '../../store/models/Secretariat';
import { RouteComponentProps } from 'react-router-dom';
import { TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import SecretariatForm from './SecretariatForm';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Card, Tab, Tabs } from '@blueprintjs/core';
import styled from '@emotion/styled';
import { css } from 'emotion';
import SecretariatPharmaciesTab from './SecretariatPharmaciesTab';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

const CardStyle = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const DashboardContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
  '& .ag-theme-balham': {
    width: '100%',
  },
});

interface SecretariatPageProps extends RouteComponentProps<{ id: string }> {
  SecretariatStore?: Instance<typeof SecretariatStore>;
}

interface SecretariatPageState {
  isLoading: boolean;
  secretariat?: Instance<typeof Secretariat>;
}

@inject('SecretariatStore', 'LocaleStore')
@observer
class SecretariatPage extends React.Component<SecretariatPageProps & WithTranslateProps, SecretariatPageState> {
  state = {
    isLoading: false,
  } as SecretariatPageState;

  _isMounted = false;

  async fetchData() {
    const { SecretariatStore } = this.props;
    const secretariatId = parseInt(this.props.match.params.id, 10);
    this._isMounted && this.setState({ isLoading: true });
    if (secretariatId > 0) {
      await SecretariatStore!.loadElement(secretariatId);
      const secretariat = SecretariatStore!.getById(secretariatId);
      this._isMounted && this.setState({ secretariat });
    }
    this._isMounted && this.setState({ isLoading: false });
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.fetchData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps: SecretariatPageProps, prevState: SecretariatPageState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchData();
    }
  }

  renderTitle = () => {
    const secretariat = this.state.secretariat;
    return secretariat !== undefined ? (
      <h1>
        {this.props.translate(TLCode.SECRETARIAT_Edit)}&nbsp;
        {secretariat!.name}
      </h1>
    ) : (
      <h1>{this.props.translate(TLCode.SECRETARIAT_Add)}</h1>
    );
  };

  save = async (data: any) => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.SecretariatStore!.saveSecretariat(data);
    this._isMounted && this.setState({ isLoading: false });
  };

  public render() {
    const { isLoading, secretariat } = this.state;
    return (
      <MainSectionLayout isLoading={isLoading} renderHeader={this.renderTitle}>
        <Container>
          <Card className={CardStyle.toString()}>
            <DashboardContainer>
              <Tabs>
                <Tab
                  id="profile"
                  title="Profil"
                  panel={<SecretariatForm secretariat={secretariat} save={this.save} />}
                />
                <Tab
                  id="pharmacies"
                  title="Pharmacies"
                  panel={<SecretariatPharmaciesTab secretariat={secretariat} />}
                />
              </Tabs>
            </DashboardContainer>
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(SecretariatPage);
